import { render, staticRenderFns } from "./UpdateStripeFeePopup.vue?vue&type=template&id=855a04e2&scoped=true&"
import script from "./UpdateStripeFeePopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateStripeFeePopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateStripeFeePopup.vue?vue&type=style&index=0&id=855a04e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855a04e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('855a04e2')) {
      api.createRecord('855a04e2', component.options)
    } else {
      api.reload('855a04e2', component.options)
    }
    module.hot.accept("./UpdateStripeFeePopup.vue?vue&type=template&id=855a04e2&scoped=true&", function () {
      api.rerender('855a04e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/UpdateStripeFeePopup.vue"
export default component.exports